<div class="edit-page-root-container item-class-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{getTitle()}}
            </div>
            <div class="action-btn-container">
             
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" *ngIf="editForm" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <!-- First Row: Code, Name, Alternative Name -->
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code"
                                        [readonly]="itemClassInfo.id!==undefined && itemClassInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">Code should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                                        10.</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="input-box-middle">
                                <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Name should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                                        50.</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="input-box-right">
                                <mat-form-field class="alternative-name">
                                    <mat-label>Alternative Name</mat-label>
                                    <input matInput formControlName="alternative_name">
                                </mat-form-field>
                            </div>
                        </div>
                        
                        <!-- Second Row: Type, Super Class, and Department -->
                        <div class="input-group">
                            <!-- Type Dropdown -->
                            <div class="input-box-left">
                                <mat-form-field class="type">
                                    <mat-label>Type</mat-label>
                                    <mat-select formControlName="type" (selectionChange)="onTypeChange($event.value)">
                                        <mat-option *ngFor="let option of typeOptions" [value]="option.value">
                                            {{option.label}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <!-- Super Class dropdown - show only when subclass is selected -->
                            <div class="input-box-middle" *ngIf="isSubclass">
                                <mat-form-field class="super-class">
                                    <mat-label>Super Class</mat-label>
                                    <input type="text" 
                                           matInput 
                                           [formControl]="superClassControl"
                                           [matAutocomplete]="superClassAuto"
                                           placeholder="Select Super Class">
                                    <button matSuffix mat-icon-button 
                                            *ngIf="selectedSuperClass"
                                            (click)="clearSuperClass()"
                                            type="button">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <mat-autocomplete #superClassAuto="matAutocomplete">
                                        <mat-option *ngFor="let superClass of filteredSuperClasses | async" 
                                                  [value]="superClass.name || superClass.className"
                                                  (onSelectionChange)="$event.isUserInput && onSuperClassSelected(superClass)">
                                            {{superClass.name || superClass.className}}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-error *ngIf="isSubclass && !selectedSuperClass && (superClassControl.touched || editForm.get('super_class_id')?.touched)">Please select superclass</mat-error>
                                </mat-form-field>
                            </div>

                            <!-- Department dropdown - always show, disabled for subclass -->
                            <div class="input-box-right">
                                <mat-form-field class="department">
                                    <mat-label>Department</mat-label>
                                    <input type="text" 
                                           matInput 
                                           [formControl]="departmentControl"
                                           [matAutocomplete]="departmentAuto"
                                           [disabled]="isSubclass"
                                           placeholder="Select Department">
                                    <button matSuffix mat-icon-button 
                                            *ngIf="selectedDepartment && !isSubclass"
                                            (click)="clearDepartment()"
                                            type="button">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <mat-autocomplete #departmentAuto="matAutocomplete">
                                        <mat-option *ngFor="let department of filteredDepartments | async" 
                                                  [value]="department.name"
                                                  (onSelectionChange)="$event.isUserInput && onDepartmentSelected(department)">
                                            {{department.name}} ({{department.code}})
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-error *ngIf="!isSubclass && !selectedDepartment && (departmentControl.touched || editForm.get('department_id')?.touched)">Please select department</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        
                        <!-- Color section - only show when is_subclass is checked -->
                        <div class="color-section" *ngIf="isSubclass">
                            <div class="sub-title">Default Item Colors</div>
                            <div class="input-group">
                                <div class="input-box-left">
                                    <mat-form-field class="color-chooser bg-color">
                                        <mat-label>BG Color</mat-label>
                                        <input matInput type="color" formControlName="bg_color">
                                    </mat-form-field>
                                </div>
                                
                                <div class="input-box-right">
                                    <mat-form-field class="color-chooser fg-color">
                                        <mat-label>FG Color</mat-label>
                                        <input matInput type="color" formControlName="fg_color">
                                    </mat-form-field>
                                </div>
                            </div>
                            
                            <div class="checkbox-group">
                                <mat-checkbox formControlName="apply_colors">Apply These Colors To Sale Items</mat-checkbox>
                            </div>
                        </div>
                        
                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description" rows="4"></textarea>
                            <mat-error *ngIf="editForm.controls['description'].hasError('maxlength')">Maximum length
                                is 250.</mat-error>
                        </mat-form-field>
                        
                        <mat-form-field class="account-code">
                            <mat-label>Account Code</mat-label>
                            <input matInput formControlName="account_code">
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>